<div class="tab-row">
  <div class="tab-container">
    <ng-content select="app-tab-bar-tab"></ng-content>
  </div>
</div>

<div class="content-container" [ngClass]="gameTenantKind === 'Company' ? 'company-bg' : 'school-bg'">
  <router-outlet></router-outlet>
</div>
